import { noop } from "lodash";
import { useEffect } from "react";
import { Controller, useFormContext } from "react-hook-form";

import type { SpaceSelectCompassComponentProps } from "./SpaceSelectCompassComponent";
import { SpaceSelectCompassComponent } from "./SpaceSelectCompassComponent";

export interface SpaceSelectCompassProps extends SpaceSelectCompassComponentProps {
  defaultValue?: number;
  name: string;
  onChange?: () => void;
  rules?: Record<string, unknown>;
}

export const SpaceSelectCompass = ({
  name,
  rules = {},
  defaultValue,
  onChange = noop,
  ...passThroughProps
}: SpaceSelectCompassProps) => {
  const { control, setValue } = useFormContext();

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);
    }
  }, [defaultValue, name, setValue]);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field, fieldState }) => (
        <SpaceSelectCompassComponent
          {...passThroughProps}
          value={field.value}
          invalid={!!fieldState.error}
          error={fieldState.error?.message}
          onChange={val => {
            field.onChange(val);
            setValue(name, val, {
              shouldDirty: true,
              shouldTouch: true,
              shouldValidate: true,
            });
            onChange?.();
          }}
        />
      )}
    />
  );
};

SpaceSelectCompass.displayName = "SpaceSelectCompass";
